import React from 'react';
import API from '../../../utils/API';
import InputField from '../../../components/inputs/inputField';
import FieldModal from '../../../components/modals/fieldModal';

class RenameFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name || '',
            submitting: false,
            requiredFields: { name: false }
        };
    }

    updateName = async () => {
        this.setState({ submitting: true });
        const { name } = this.state;
        const { orgId, formId, update, toggle, form } = this.props;
        if (!name) {
            this.setState({ submitting: false, requiredFields: { name: true } });
            return;
        }
        await API()
            .patch(`Organizations/${orgId}/accountForms/${formId}`, { name, pages: form.pages })
            .then((res) => {
                if (res.data) {
                    update(name, toggle);
                }
            })
            .catch(() => this.setState({ submitting: false }));
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, name, requiredFields } = this.state;
        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle="Rename Form"
                bodyHeaderText="Enter a new name for your form."
                bodyContent={() => (
                    <InputField
                        label="Name"
                        value={name}
                        required={true}
                        errorTrigger={requiredFields.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                    />
                )}
                toggle={toggle}
                actionButtonLabel={submitting ? 'Saving...' : 'Save'}
                cancelButtonLabel="Cancel"
                actionButton={this.updateName}
                submitting={submitting}
                actionButtonDisabled={submitting}
            />
        );
    }
}

export default RenameFormModal;
